import BlogGridView from "../../../commonComponents/blogGridView";

const BlogLeftSidebarContainer = () => {
  return <BlogGridView gridSize={3} />;
};

export default BlogLeftSidebarContainer;
